import React from 'react';
import { Paper, makeStyles, Container } from '@material-ui/core';

const useStyle = (img, font, height = 250) =>
	makeStyles(theme => {
		const {
			palette,
			breakpoints: { down },
			spacing,
		} = theme;
		return {
			root: {
				background: `url('${img}')`,
				backgroundSize: 'cover',
				backgroundPosition: 'center top',
				width: '100%',
				height: height,
				display: 'flex',
				cursor: 'pointer',
				borderRadius: '2px',
				overflow: 'hidden',
				border: `3px solid ${palette.primary.light}`,
				'&:hover': {
					'& > *': {
						background: 'rgba(0,0,0,0.1)',
					},
				},
				[down('sm')]: {
					width: '95%',
					height: '28vh',
					transform: 'filter(0.8)',
				},
			},
			cover: {
				fontFamily: font.family,
				color: 'white',
				fontSize: font.size,
				fontWeight: '300',
				background: 'rgba(0,0,0,0.5)',
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				flexDirection: 'column',
				justifyContent: 'flex-end',
				height: '100%',
				transition: '400ms all ease-in',
				borderRadius: '2px',
				padding: spacing(3),
				[down('sm')]: {
					fontSize: '1.3rem',
					background: 'rgba(0,0,0,0.3)',
					padding: spacing(1.5),
				},
			},
		};
	});

const ImageMask = ({
	img,
	title,
	height,
	defaultText,
	font = { family: 'Montserrat', size: '18px' },
}) => {
	const style = useStyle(img, font, height)();
	return (
		<Paper className={style.root} elevation={0}>
			<Container className={style.cover}>
				{title}
				<div>{defaultText}</div>
			</Container>
		</Paper>
	);
};

export default ImageMask;
